import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Key } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/admin/org/api-keys')({
  component: OrgApiKeysPage,
});

function OrgApiKeysPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Organization API Keys</h1>
        <p className="text-muted-foreground">Manage API keys for your organization</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Key className="h-5 w-5" />
            API Keys
          </CardTitle>
          <CardDescription>Create and manage organization-level API keys</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">API key management interface coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
